import React, { useState, useEffect } from 'react';
const API_BASE_URL = "https://final-project-5ar7.onrender.com";

const EMPTY = { label: '', accountName: '', accountNumber: '', bankName: '', ifscCode: '', accountType: 'Current Account', isActive: false, allowAllUsers: true, note: '' };

export default function BankSettings() {
  const [gateways, setGateways] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [editId, setEditId] = useState(null);
  const [saving, setSaving] = useState(false);

  const fetchGateways = async () => {
    const res = await fetch(`${API_BASE_URL}/api/admin/public/bank-gateways`);
    const data = await res.json();
    if (data.success) setGateways(data.gateways);
  };

  useEffect(() => { fetchGateways(); }, []);

  const handleSave = async () => {
    if (!form.label || !form.accountName || !form.accountNumber || !form.bankName || !form.ifscCode) {
      alert('Please fill all required fields'); return;
    }
    setSaving(true);
    const url = editId ? `${API_BASE_URL}/api/admin/public/bank-gateways/${editId}` : `${API_BASE_URL}/api/admin/public/bank-gateways`;
    await fetch(url, { method: editId ? 'PUT' : 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form) });
    setForm(EMPTY); setEditId(null); setSaving(false); fetchGateways();
  };

  const handleEdit = (gw) => { setEditId(gw._id); setForm({ label: gw.label, accountName: gw.accountName, accountNumber: gw.accountNumber, bankName: gw.bankName, ifscCode: gw.ifscCode, accountType: gw.accountType, isActive: gw.isActive, allowAllUsers: gw.allowAllUsers, note: gw.note || '' }); };
  const handleDelete = async (id) => { if (!window.confirm('Delete this bank gateway?')) return; await fetch(`${API_BASE_URL}/api/admin/public/bank-gateways/${id}`, { method: 'DELETE' }); fetchGateways(); };
  const handleToggle = async (gw) => { await fetch(`${API_BASE_URL}/api/admin/public/bank-gateways/${gw._id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...gw, isActive: !gw.isActive }) }); fetchGateways(); };

  const card = { background: '#fff', borderRadius: 12, padding: 24, marginBottom: 20, boxShadow: '0 2px 12px rgba(0,0,0,0.08)', border: '1px solid #e5e7eb' };
  const inp = { width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' };

  return (
    <div style={{ padding: 32, maxWidth: 860, margin: '0 auto' }}>
      <h1 style={{ fontSize: 28, fontWeight: 700, color: '#1a1a2e', marginBottom: 8 }}>🏦 Bank Transfer Settings</h1>
      <p style={{ color: '#6b7280', marginBottom: 32 }}>Manage bank account details shown to users during deposits.</p>

      <div style={card}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 16 }}>{editId ? '✏️ Edit Bank Account' : '➕ Add New Bank Account'}</h2>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          {[['Label *', 'label', 'e.g. HDFC Main Account'], ['Account Name *', 'accountName', 'e.g. Tradex Securities Pvt Ltd'], ['Account Number *', 'accountNumber', 'e.g. 123456789012'], ['Bank Name *', 'bankName', 'e.g. HDFC BANK LTD'], ['IFSC Code *', 'ifscCode', 'e.g. HDFC0001234'], ['Account Type', 'accountType', 'e.g. Current Account']].map(([label, key, ph]) => (
            <div key={key}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>{label}</label>
              <input value={form[key]} onChange={e => setForm(p => ({ ...p, [key]: e.target.value }))} placeholder={ph} style={inp} />
            </div>
          ))}
          <div style={{ gridColumn: '1/-1' }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }}>Note for User (optional)</label>
            <input value={form.note} onChange={e => setForm(p => ({ ...p, note: e.target.value }))} placeholder="e.g. Please include your UTR number in the receipt upload" style={inp} />
          </div>
        </div>
        <div style={{ display: 'flex', gap: 24, marginTop: 16 }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 14 }}>
            <input type="checkbox" checked={form.isActive} onChange={e => setForm(p => ({ ...p, isActive: e.target.checked }))} />
            Active (visible to users)
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 14 }}>
            <input type="checkbox" checked={form.allowAllUsers} onChange={e => setForm(p => ({ ...p, allowAllUsers: e.target.checked }))} />
            Show to all approved users
          </label>
        </div>
        <div style={{ display: 'flex', gap: 12, marginTop: 20 }}>
          <button onClick={handleSave} disabled={saving} style={{ background: '#1d4ed8', color: '#fff', border: 'none', padding: '10px 24px', borderRadius: 8, cursor: 'pointer', fontWeight: 700, fontSize: 14 }}>
            {saving ? 'Saving...' : editId ? '💾 Update' : '➕ Add Gateway'}
          </button>
          {editId && <button onClick={() => { setForm(EMPTY); setEditId(null); }} style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', padding: '10px 20px', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>Cancel</button>}
        </div>
      </div>

      {gateways.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 48, color: '#9ca3af' }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>🏦</div>
          <p>No bank gateways yet. Add one above.</p>
        </div>
      ) : gateways.map(gw => (
        <div key={gw._id} style={{ ...card, border: `1px solid ${gw.isActive ? '#bbf7d0' : '#e5e7eb'}` }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                <span style={{ fontSize: 16, fontWeight: 700, color: '#1a1a2e' }}>{gw.label}</span>
                <span style={{ background: gw.isActive ? '#dcfce7' : '#f3f4f6', color: gw.isActive ? '#166534' : '#6b7280', padding: '2px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600 }}>{gw.isActive ? '✅ Active' : '⏸ Inactive'}</span>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 24px', fontSize: 13, color: '#374151' }}>
                <span>Account Name: <b>{gw.accountName}</b></span>
                <span>Account Number: <b>{gw.accountNumber}</b></span>
                <span>Bank: <b>{gw.bankName}</b></span>
                <span>IFSC: <b>{gw.ifscCode}</b></span>
                <span>Type: <b>{gw.accountType}</b></span>
              </div>
              {gw.note && <p style={{ margin: '8px 0 0', fontSize: 12, color: '#6b7280' }}>Note: {gw.note}</p>}
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button onClick={() => handleToggle(gw)} style={{ background: gw.isActive ? '#fef3c7' : '#dcfce7', border: 'none', padding: '6px 14px', borderRadius: 7, cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>{gw.isActive ? 'Deactivate' : 'Activate'}</button>
              <button onClick={() => handleEdit(gw)} style={{ background: '#eff6ff', color: '#1d4ed8', border: 'none', padding: '6px 14px', borderRadius: 7, cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>Edit</button>
              <button onClick={() => handleDelete(gw._id)} style={{ background: '#fef2f2', color: '#dc2626', border: 'none', padding: '6px 14px', borderRadius: 7, cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>Delete</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}